<lib-generic-carousel [banners]="banners" [showNavigationArrows]="false"></lib-generic-carousel>
